import {
  getBackendEnvironment,
  PRODUCTION_BACKEND_ENVIRONMENT,
} from 'lib/helpers/getBackendEnvironment/getBackendEnvironment'

interface GetCookieNamePrefixParams {
  backendUrl: Maybe<string>
}

/**
 * Every environment lives under `settle.co`, and the auth cookies are even set on that shared domain
 * (see useSetTokenCookie), so a cookie name shared across environments collides with production's.
 * Cookies are therefore prefixed with the environment of the backend they belong to; production keeps
 * the bare names so existing sessions and remembered devices survive.
 */
export const getCookieNamePrefix = ({ backendUrl }: GetCookieNamePrefixParams): string => {
  const environment = getBackendEnvironment({ backendUrl })

  return environment && environment !== PRODUCTION_BACKEND_ENVIRONMENT ? `${environment}_` : ''
}
